import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-full font-mono text-sm" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }

import {
  toRefs, ref, onBeforeUnmount, onMounted,
} from 'vue';
import { useClipboard } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  props: ['node'],
  setup(__props) {

const props = __props


const { node } = toRefs(props);
const displayValue = ref(null);

const { copy, copied, isSupported: canCopy } = useClipboard();

function checkOverflow(element: Element) {
  return element.scrollHeight > element.clientHeight
    || element.scrollWidth > element.clientWidth;
}

function updateOverflowing() {
  if (node.value.opened || !displayValue.value) return;
  node.value.setOverflowing(checkOverflow(displayValue.value));
}

if (!node.value.isCollection) {
  onMounted(updateOverflowing);
  window.addEventListener('resize', updateOverflowing);
  onBeforeUnmount(() => window.removeEventListener('resize', updateOverflowing));
}

return (_ctx: any,_cache: any) => {
  const _component_json_explorer_node = _resolveComponent("json-explorer-node", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["group relative w-full flex items-center pr-4 py-1", {
        'cursor-pointer': _unref(node).hasChildren,
        'break-all': _unref(node).wrapMode,
        'hover:bg-gray-100': _unref(node).indent > 0 || _unref(node).hasChildren,
      }]),
      style: _normalizeStyle(`padding-left: ${_unref(node).getLeftPadding()}rem`),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(node).hasChildren ? _unref(node).toggle() : null)),
      onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_unref(node).hasChildren ? _unref(node).toggle() : null), ["enter"]))
    }, [
      (! _unref(node).wrapMode)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["mr-1 flex-shrink-0 text-gray-400 text-xs transform transition", [
          _unref(node).opened ? 'rotate-90' : 'rotate-0',
          _unref(node).hasChildren ? '' : 'opacity-0',
        ]])
          }, "►", 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["text-gray-500", _unref(node).wrapMode ? '' : 'truncate']),
        ref_key: "displayValue",
        ref: displayValue
      }, [
        (_unref(node).hasKey)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              textContent: _toDisplayString(`${_unref(node).key}: `),
              class: "text-indigo-600"
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("span", {
          textContent: _toDisplayString(_unref(node).displayValue),
          class: _normalizeClass([
            _unref(node).displayClasses,
            _unref(node).overflowing && _unref(node).opened ? 'hidden' : '',
          ])
        }, null, 10, _hoisted_3),
        (_unref(node).isCollection && _unref(node).hasChildren && ! _unref(node).opened)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              textContent: _toDisplayString(` ${_unref(node).preview}`),
              class: "italic text-gray-400 hidden group-hover:inline"
            }, null, 8, _hoisted_4))
          : _createCommentVNode("", true)
      ], 2),
      (_unref(canCopy))
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "absolute right-0 top-0 mr-4 flex items-center justify-center my-1 px-2 h-5 bg-white text-xs font-sans hover:bg-gray-50 rounded border border-gray-400 shadow hover:shadow-md opacity-0 group-hover:opacity-100",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(copy)(_unref(node).copyValue)), ["stop"])),
            onKeypress: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_unref(copy)(_unref(node).copyValue)), ["enter"]))
          }, [
            (!_unref(copied))
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Copy"))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, "Copied!"))
          ], 32))
        : _createCommentVNode("", true)
    ], 38),
    (_unref(node).hasChildren && _unref(node).opened)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(node).children, (child) => {
            return (_openBlock(), _createElementBlock("li", {
              key: child.key
            }, [
              _createVNode(_component_json_explorer_node, { node: child }, null, 8, ["node"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})